import { Controller } from "@hotwired/stimulus";

const STORAGE_KEY = "theme";

export default class extends Controller {
  static targets = ["button"];

  connect() {
    this.updateButtons();
  }

  setLight() {
    this.apply("light");
  }

  setDark() {
    this.apply("dark");
  }

  apply(theme) {
    document.documentElement.dataset.theme = theme;
    this.updateButtons();
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch (error) {
      // A browser can block storage while still allowing a theme change on this page.
    }
  }

  updateButtons() {
    const theme = document.documentElement.dataset.theme === "dark" ? "dark" : "light";
    this.buttonTargets.forEach((button) => {
      button.setAttribute("aria-pressed", String(button.dataset.themeSeg === theme));
    });
  }
}
